import { render, staticRenderFns } from "./HodimOylik.vue?vue&type=template&id=b51c828c&scoped=true"
import script from "./HodimOylik.vue?vue&type=script&lang=js"
export * from "./HodimOylik.vue?vue&type=script&lang=js"
import style0 from "./HodimOylik.vue?vue&type=style&index=0&id=b51c828c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51c828c",
  null
  
)

export default component.exports